<cc-filter-dropdown-anchor
    #anchor
    [showClearButton]="false"
    [label]="'additional filters'"
    [displayText]="anchorText"
    (toggleList)="showModal = !showModal"
>
</cc-filter-dropdown-anchor>

@if (showModal) {
    <ddv-dashboard-filters-modal
        [ccModal]="modalOptions"
        (dismissed)="showModal = false"
        [widgetId]="widgetId"
        [dashboardFilters]="filtersCopy"
        (filtersApplied)="onFiltersApplied($event)"
    >
    </ddv-dashboard-filters-modal>
}
